export const sortNestedTree = (items: any[], sortKey: string): any[] => items
  .map(item => item.children
    ? { ...item, children: sortNestedTree(item.children, sortKey) }
    : item
  )
  .sort((i1, i2) => {
    if (i1[sortKey] < i2[sortKey]) {
      return -1;
    }
    return 1;
  });
